import { LoadingButton } from "@mui/lab";
import { Alert, Stack, TextField } from "@mui/material";
import { ChangeEvent, useState } from "react";
import { ForumService, IdeaDto } from "../../../api/psc";
import { DialogContainer, DialogHeader } from "../../../components/exports";

export default function CreateOrUpdateIdeaDialog(props: {
    idea?: IdeaDto;
    onCreateOrUpdate: (idea: IdeaDto) => void;
}) {
    const [ideaCreated, setIdeaCreated] = useState(false);
    const [requestInProgress, setRequestInProgress] = useState(false);
    const [title, setTitle] = useState(props.idea?.title ?? "");
    const [description, setDescription] = useState(
        props.idea?.description ?? ""
    );

    const handleTitleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setTitle(event.target.value);
    };

    const handleDescriptionChange = (event: ChangeEvent<HTMLInputElement>) => {
        setDescription(event.target.value);
    };

    const handleSubmitIdea = () => {
        setRequestInProgress(true);

        const request = props.idea
            ? ForumService.updateIdea(props.idea.id, "1", {
                  title: title,
                  description: description,
              })
            : ForumService.createIdea("1", {
                  title: title,
                  description: description,
              });

        request
            .then((r) => {
                setIdeaCreated(true);
                props.onCreateOrUpdate(r);
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    return (
        <DialogContainer>
            <DialogHeader title="ساخت / ویرایش تیکت جدید" />

            <Stack sx={{ p: 2 }} spacing={2}>
                {ideaCreated && (
                    <Alert severity="success">
                        تیکت شما توسط ادمین بررسی شده و به آن پاسخ داده خواهد شد
                    </Alert>
                )}

                {!ideaCreated && (
                    <>
                        <TextField
                            value={title}
                            fullWidth
                            label="عنوان"
                            onChange={handleTitleChange}
                            maxRows={6}
                        />

                        <TextField
                            value={description}
                            fullWidth
                            label="توضیحات"
                            multiline
                            onChange={handleDescriptionChange}
                            rows={3}
                            maxRows={6}
                        />

                        <LoadingButton
                            variant="contained"
                            loading={requestInProgress}
                            onClick={handleSubmitIdea}
                        >
                            ایجاد تیکت
                        </LoadingButton>
                    </>
                )}
            </Stack>
        </DialogContainer>
    );
}
